(function () {
  // Find the section id from our gallery marker
  function getSectionId() {
    var marker = document.querySelector('[data-product-section-id]');
    return marker ? marker.getAttribute('data-product-section-id') : null;
  }

  // Which product form is on the page
  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? input.value : null;
  }

  // Replace the whole product section
  async function refreshSection() {
    var sectionId = getSectionId();
    if (!sectionId) return;

    var container = document.querySelector('#shopify-section-' + CSS.escape(sectionId));
    if (!container) return;

    // Build URL keeping current query params and forcing section render
    var url = new URL(window.location.href);
    var variantId = currentVariantId();
    if (variantId) url.searchParams.set('variant', variantId);
    url.searchParams.set('sections', sectionId); // Section Rendering API

    var scrollY = window.scrollY;

    var html;
    try {
      html = await fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); });
    } catch (e) {
      console.warn('[variant-section-refresh] fetch failed', e);
      return;
    }
    if (!html) return;

    // Response is a JSON-ish or raw HTML depending on theme; handle both
    var freshHtml = html;
    try {
      // If JSON of {sectionId: "<html>"} was returned
      var obj = JSON.parse(html);
      if (obj && obj[sectionId]) freshHtml = obj[sectionId];
    } catch (_) {}

    // Parse and swap
    var parser = new DOMParser();
    var doc = parser.parseFromString(freshHtml, 'text/html');
    var fresh = doc.querySelector('#shopify-section-' + CSS.escape(sectionId)) || doc.body.firstElementChild;
    if (!fresh) {
      // If the response was just the inner HTML
      container.innerHTML = freshHtml;
    } else {
      container.replaceWith(fresh);
    }

    // Restore scroll and notify theme scripts
    window.scrollTo({ top: scrollY });
    document.dispatchEvent(new Event('shopify:section:load'));
  }

  // Wire up: listen for as many variant-change signals as possible
  function bind() {
    var handler = function () { setTimeout(refreshSection, 50); };

    document.addEventListener('variant:change', handler);
    document.addEventListener('product:variant-change', handler);

    // Fallback: any change inside add-to-cart form
    document.addEventListener('change', function (e) {
      var form = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (form) handler();
    });

    // If the theme pushes ?variant= in the URL, refresh on history changes too
    window.addEventListener('popstate', handler);
  }

  document.addEventListener('DOMContentLoaded', bind);
})();
